import React, { useEffect, useState } from 'react';
import { FaArrowLeft, FaTrash } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import CustomInputDate from '../../../../components/CustomInputs/CustomInputDate';
import CustomInputMask from '../../../../components/CustomInputs/CustomInputMask';
import CustomInputText from '../../../../components/CustomInputs/CustomInputText';
import CustomModal from '../../../../components/CustomModal';
import CustomOffcanvas from '../../../../components/CustomOffcanvas';
import CustomRow from '../../../../components/CustomRow';
import CustomSelect from '../../../../components/CustomSelects/CustomSelect';
import CustomTable from '../../../../components/CustomTable';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceBotoesNew from '../../../../components/WorkspaceBotoes/indexNew';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { LogData } from '../../../../modules/types/types';
import { useCargoFuncao } from '../../../../services/enum/useCargoFuncao';
import { useGeneros } from '../../../../services/enum/useGeneros';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { getFornecedor } from '../../../../services/fornecedoresDAF/fornecedorService';
import { getRepresentantesByFornecedor } from '../../../../services/fornecedoresDAF/representantesService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import theme from '../../../../theme';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataCPF,
  formataNomeMeioSiglas,
  formatDate,
  getToken,
} from '../../../../utils/functions';
import {
  fieldObjectSes as fieldObject,
  headersSesUsuarios,
} from '../SES/auxiliarSES';
import SubAbasSES from '../SES/subabasSES';

function SESUsuarios() {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_FornecedorRepresentante;

  const [showDetalhesUsuario, setShowDetalhesUsuario] = useState(false);

  const [listaUsuariosEncontrados, setListaUsuariosEncontrados] = useState<
    any[]
  >([]);
  const [usuarioSelecionadoId, setUsuarioSelecionadoId] = useState<
    number | null
  >(null);
  const [usuarioVinculadoSelecionado, setUsuarioVinculadoSelecionado] =
    useState<any>(null);

  const handleRowClickUsuarioVinculado = (payload: any) => {
    const clickedId =
      payload && typeof payload === 'object'
        ? 'id' in payload
          ? (payload as any).id
          : ((payload as any)?.original?.id ??
            (payload as any)?.row?.id ??
            (payload as any)?.values?.id)
        : payload;

    let usuario: any | undefined;

    if (clickedId != null) {
      usuario = usuariosVinculados.find(
        (item) => String(item.id) === String(clickedId),
      );
    }

    if (!usuario && Number.isInteger(clickedId)) {
      usuario = usuariosVinculados[Number(clickedId)];
    }

    if (!usuario) {
      console.warn(
        '[Tabela.onRowClick] Usuário não localizado para payload:',
        payload,
      );
      return;
    }

    setUsuarioVinculadoSelecionado(usuario);
    setShowDetalhesUsuario(true);
  };

  const [, setDesvinculando] = useState(false);
  const params = useParams();
  const fichaID = String(params.id);

  const subAbas = SubAbasSES(fichaID);
  const generoOptions = useGeneros();
  const cargoOptions = useCargoFuncao();

  const [, setShowModal] = useState<boolean>(false);
  const [, setLogData] = useState<LogData>();
  const [data, setData] = useState<any[]>([]);

  const [formRepresentante, setFormRepresentante] = useState({
    generoSexual: 0,
    cargoFuncao: 0,
    cpf: '',
    nomeCompleto: '',
    dataNascimento: '',
    telefone: '',
    celular: '',
    email: '',
    linkedin: '',
    observacoes: '',

    usuarioRegistroId: userID,
    sesId: parseInt(fichaID, 10),
  });

  const [formFornecedor, setFormFornecedor] = useState({
    sesId: 0,
    cnpj: '',
    razaoSocial: '',
    ip: '',
  });

  const fetchData = async (id: string) => {
    try {
      const representantesData = await getRepresentantesByFornecedor(id);
      const fornecedorData = await getFornecedor(id);
      setData(representantesData);
      setFormRepresentante({
        generoSexual: representantesData.generoSexual,
        cargoFuncao: representantesData.cargoFuncao,
        cpf: representantesData.cpf,
        nomeCompleto: representantesData.nomeCompleto,
        dataNascimento: representantesData.dataNascimento,
        telefone: representantesData.telefone,
        celular: representantesData.celular,
        email: representantesData.email,
        linkedin: representantesData.linkedin,
        observacoes: representantesData.observacoes,

        // chave usuário
        usuarioRegistroId: userID,
        // chave fornecedor
        sesId: parseInt(fichaID, 10),
      });
      setFormFornecedor({
        sesId: fornecedorData.id,
        cnpj: fornecedorData.cnpj,
        razaoSocial: fornecedorData.razaoSocial,
        ip: fornecedorData.ip || '',
      });
      setLogData({
        id: representantesData.id,
        usuarioRegistro: representantesData.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          representantesData.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: representantesData.dataRegistro,
        dataAtualizacao: representantesData.dataUltimaAtualizacao,
        nEdicoes: representantesData.nEdicoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData(fichaID);
  }, []);

  //Dados do Offcanvas
  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    cpf: item.cpf,
    nomeCompleto: item.nomeCompleto,
    cargoFuncao: cargoOptions[item.cargoFuncao].label,
    dataNascimento: item.dataNascimento,
    generoSexual: generoOptions[item.generoSexual].label,
    celular: item.celular,
    telefone: item.telefone,
    email: item.email,
    linkedin: item.linkedin,
    observacoes: item.observacoes,
  }));

  const exportData = data.map((item) => ({
    //Dados da entidade
    id: item.id,
    nomeCompleto: item.nomeCompleto,
    cpf: item.cpf,
    cargoFuncao: cargoOptions[item.cargoFuncao].label,
    dataNascimento: item.dataNascimento,
    generoSexual: generoOptions[item.generoSexual].label,
    celular: item.celular,
    telefone: item.telefone,
    email: item.email,
    linkedin: item.linkedin,
    observacoes: item.observacoes,

    //Dados do Fornecedor
    sesId: formFornecedor.sesId,
    cnpj: formFornecedor.cnpj,
    razaoSocial: formFornecedor.razaoSocial,

    //Logs
    dataRegistro: item.dataRegistro,
    dataUltimaAtualizacao: item.dataUltimaAtualizacao,
    dataUltimaVisualizacao: item.dataUltimaVisualizacao,
    usuarioRegistro: formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    usuarioAtualizacao: formataNomeMeioSiglas(
      item.usuarioAtualizacao.nomeCompleto,
    ),
    usuarioUltimaVisualizacao: formataNomeMeioSiglas(
      item.usuarioUltimaVisualizacao.nomeCompleto,
    ),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
  }));

  const [showModalVinculoUsuario, setShowModalVinculoUsuario] =
    useState<boolean>(false);

  const [formVinculoUsuario] = useState<{
    id: string;
    tpVinculo: number;
  }>({
    id: '0',
    tpVinculo: 0,
  });

  const handleShowModalVinculoUsuario = () => {
    setShowModalVinculoUsuario((prev) => !prev);
  };

  const [cpfBusca, setCpfBusca] = useState('');

  const [usuarioEncontrado, setUsuarioEncontrado] = useState<any>(null);
  const [usuarioEncontradoId, setUsuarioEncontradoId] = useState<number | null>(
    null,
  );
  const [usuariosVinculados, setUsuariosVinculados] = useState<any[]>([]);

  const fetchUsuariosVinculadosPorCnpj = async () => {
    try {
      const response = await httpClient.get(`/api/usuariointerface`, {
        params: {
          coSes: formRepresentante.sesId,
          //   cnpj: cnpjLimpo,
          nuInterfaceSisaf: 3,
          stRegistroAtivo: 'S',
        },
      });

      setUsuariosVinculados(response.data.relacoes || []);
    } catch (error) {
      console.error('Erro ao buscar usuários vinculados:', error);
      CustomSwal.quick('error', 'Erro ao buscar usuários vinculados.');
    }
  };

  const handleBuscarUsuario = async () => {
    const buscaBruta = cpfBusca?.trim();
    if (!buscaBruta) return;

    try {
      const token =
        typeof window !== 'undefined' ? localStorage.getItem('token') : null;

      const cpfRegex = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
      const isCpf = cpfRegex.test(buscaBruta);
      const cpfLimpo = buscaBruta.replace(/\D/g, '');

      if (!isCpf && buscaBruta.length < 2) {
        CustomSwal.quick(
          'warning',
          'Digite pelo menos 2 caracteres para o nome.',
        );
        return;
      }

      const params: Record<string, any> = isCpf
        ? { cpf: cpfLimpo }
        : { nome: buscaBruta };

      const response = await httpClient.get(`/api/users`, {
        params,
        headers: {
          Accept: 'application/json',
        },
      });

      const users: any[] = Array.isArray(response?.data?.users)
        ? response.data.users
        : [];

      const getRoles = (u: any): number[] => {
        if (Array.isArray(u?.papeisArray))
          return u.papeisArray
            .map((x: any) => Number(x))
            .filter(Number.isFinite);
        if (u?.papel != null) return [Number(u.papel)].filter(Number.isFinite);
        return [];
      };
      const isAdmin = (u: any) => getRoles(u).includes(1);

      const naoAdmins = users.filter((u) => !isAdmin(u));

      if (naoAdmins.length > 0) {
        naoAdmins.sort((a, b) =>
          String(a?.nomeCompleto || '').localeCompare(
            String(b?.nomeCompleto || ''),
            'pt-BR',
          ),
        );
        setListaUsuariosEncontrados(naoAdmins);
        setUsuarioEncontrado(naoAdmins[0]);
        setUsuarioEncontradoId(naoAdmins[0].id);
        return;
      }

      if (users.length > 0) {
        setListaUsuariosEncontrados([]);
        setUsuarioEncontrado(null);
        setUsuarioEncontradoId(null);
        CustomSwal.quick(
          'info',
          'A busca retornou apenas administradores. Refine os filtros ou ajuste o critério.',
        );
        return;
      }

      setListaUsuariosEncontrados([]);
      setUsuarioEncontrado(null);
      setUsuarioEncontradoId(null);
      CustomSwal.quick(
        'error',
        'Usuário não encontrado. Verifique o CPF ou nome.',
      );
    } catch (error: any) {
      console.error('Erro ao buscar usuário:', error);
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        CustomSwal.quick('error', 'Sua sessão expirou. Faça login novamente.');
      } else {
        CustomSwal.quick(
          'error',
          'Erro ao buscar usuário. Verifique os dados e tente novamente.',
        );
      }
    }
  };

  const isAtivo = (r: any) => String(r?.statusRegistroAtivo) === 'S';

  const getRolesFromUser = (u: any): number[] => {
    if (Array.isArray(u?.papeisArray)) {
      return u.papeisArray.map((x: any) => Number(x)).filter(Number.isFinite);
    }
    if (u?.papel != null) {
      return [Number(u.papel)].filter(Number.isFinite);
    }
    return [];
  };

  const isAdminUser = (u: any) => getRolesFromUser(u).includes(1);

  const isUsuarioVinculadoEmOutraInterfacePorId = async (
    coUsuario: number,
    token: string,
  ): Promise<boolean> => {
    const resp = await httpClient.get(`/api/usuariointerface`, {
      params: {
        coUsuario,
        stRegistroAtivo: 'S',
      },
    });

    const relacoes: any[] = Array.isArray(resp?.data?.relacoes)
      ? resp.data.relacoes
      : Array.isArray(resp?.data)
        ? resp.data
        : [];

    return relacoes.some(
      (r) => isAtivo(r) && Number(r?.nuInterfaceSisaf) !== 3,
    );
  };

  const handleVincularUsuario = async () => {
    if (!usuarioEncontrado) return;
    if (!validateFormVinculo()) return;

    try {
      const token = await getToken();

      const coSesStr = String(fichaID).trim();
      const tpVinculoNum = Number(formVinculoUsuario.tpVinculo);
      const coUsuarioNum = Number(usuarioEncontradoId);
      const coUsuarioVinculacaoNum = Number(userID);

      if (isAdminUser(usuarioEncontrado)) {
        CustomSwal.quick(
          'warning',
          'Usuários administradores não podem ser vinculados a SES.',
        );
        return;
      }

      const vinculoOutraInterface =
        await isUsuarioVinculadoEmOutraInterfacePorId(coUsuarioNum, token);
      if (vinculoOutraInterface) {
        CustomSwal.quick(
          'warning',
          'Este usuário já possui vínculo ativo em outra interface. Operação bloqueada.',
        );
        return;
      }

      if (!coSesStr) {
        CustomSwal.quick('error', 'SES inválida.');
        return;
      }

      const existeRepresentanteAtivo = usuariosVinculados.some((u) => {
        const v = u.tpVinculo;
        const ehRT = v === 1 || v === '1' || v === 'R';
        const ativo =
          String(u.statusRegistroAtivo) === 'S' ||
          String(u.statusInterface) === 'S';
        return ehRT && ativo;
      });
      if (tpVinculoNum === 1 && existeRepresentanteAtivo) {
        CustomSwal.quick(
          'warning',
          'Já existe um Representante Técnico ativo para este CNPJ.',
        );
        return;
      }

      const baseDto = {
        coUsuario: coUsuarioNum,
        coUsuarioVinculacao: coUsuarioVinculacaoNum,
        nuInterfaceSisaf: 3,
        coSes: coSesStr,
        dtVinculacao: new Date().toISOString(),
        dsObservacao: 'Vínculo realizado via interface de administração.',
        stInterface: 'N',
        stRegistroAtivo: 'S',
        tpVinculo: 2,
      };

      const patchBody: any = {
        coUsuario: coUsuarioNum,
        coSes: coSesStr,
        dto: { ...baseDto },
      };

      const postBody = { ...baseDto };

      let vinculoOk = false;

      try {
        await httpClient.patch(
          `/api/usuariointerface/usuario-fornecedor-ses`,
          patchBody,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        vinculoOk = true;
      } catch (err: any) {
        const status = err?.response?.status;
        if (status === 400 || status === 404 || status === 409) {
          const respPost = await httpClient.post(
            `/api/usuariointerface`,
            postBody,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );
          vinculoOk = respPost.status === 201 || respPost.status === 200;
        } else {
          throw err;
        }
      }

      if (!vinculoOk) {
        CustomSwal.quick('error', 'Não foi possível vincular o usuário.');
        return;
      }

      await httpClient.patch(`/api/users/${usuarioEncontradoId}`, {
        stRegistroAtivo: 'S',
      });

      CustomSwal.quick('success', 'Usuário vinculado com sucesso!');
      setShowModalVinculoUsuario(false);
      setCpfBusca('');
      setUsuarioEncontrado(null);
      await fetchUsuariosVinculadosPorCnpj();
    } catch (error: any) {
      console.error('Erro ao vincular usuário:', error);
      if (isHttpError(error)) {
        const msg =
          error.response?.data?.message ||
          error.message ||
          'Erro ao vincular usuário';
        CustomSwal.quick('error', msg);
      } else {
        CustomSwal.quick(
          'error',
          'Erro ao vincular usuário. Tente novamente mais tarde.',
        );
      }
    }
  };

  const handleDesvincularUsuario = async (id: number) => {
    try {
      await httpClient.delete(`/api/usuariointerface/${id}`);
      await httpClient.patch(
        `/api/users/${usuarioVinculadoSelecionado?.usuarioId?.id}`,
        {
          stRegistroAtivo: 'N',
        },
      );

      CustomSwal.quick('success', 'Usuário desvinculado com sucesso.');
      handleShowDetalhes();
      fetchUsuariosVinculadosPorCnpj();
    } catch (error) {
      console.error('Erro ao desvincular usuário:', error);
      CustomSwal.quick('error', 'Erro ao desvincular usuário.');
    } finally {
      setDesvinculando(false);
    }
  };

  const handleShowDetalhes = () => {
    setShowDetalhesUsuario(false);
    setUsuarioVinculadoSelecionado(null);
  };

  const valoresExibidos = {
    nomeCompleto: 'Nome',
    cpf: 'CPF',
    cargoFuncao: 'Cargo',
    dataNascimento: 'Nascimento',
    generoSexual: 'Gênero',
    celular: 'Celular',
    telefone: 'Telefone',
    email: 'Email',
    linkedin: 'LinkedIn',
    observacoes: 'Observações',
    dataRegistro: 'Data Registro',
    dataUltimaAtualizacao: 'Última Atualização',
    dataUltimaVisualizacao: 'Última Visualização',
    nEdicoes: 'Nº Edições',
    nVisualizacoes: 'Nº Visualizações',
  };

  const tableData = usuariosVinculados.map((item) => ({
    id: item.id,
    status: item.statusInterface,
    nome: item.usuarioId?.nomeCompleto || '---',
    cpf: formataCPF(item.usuarioId?.cpf) || '---',
    celular: item.usuarioId?.celular || '---',
    email: item.usuarioId?.emailPessoal || '---',
    dataVinculacao: formatDate(item.dataVinculacao),
    responsavelVinculacao: item.usuarioVinculacao?.nomeCompleto || '---',
  }));

  useEffect(() => {
    fetchData(fichaID);
  }, [fichaID]);

  useEffect(() => {
    if (formFornecedor.cnpj) {
      fetchUsuariosVinculadosPorCnpj();
    }
  }, [formFornecedor.cnpj]);

  const validateFormVinculo = () => {
    const errors: string[] = [];

    if (
      formVinculoUsuario.tpVinculo === null ||
      formVinculoUsuario.tpVinculo === undefined
    ) {
      errors.push('<b>Tipo de Vínculo</b> é obrigatório.');
    }

    if (!usuarioEncontrado) {
      errors.push('<b>Usuário</b> deve ser pesquisado e selecionado.');
    }

    if (errors.length > 0) {
      CustomSwal.quick('warning', errors.join('<br>'));
      return false;
    }

    return true;
  };

  const handleAtualizarTpVinculo = async () => {
    try {
      if (usuarioVinculadoSelecionado.tpVinculo === 1) {
        const jaExisteOutro = usuariosVinculados.some(
          (u) =>
            u.tpVinculo === 1 &&
            u.id !== usuarioVinculadoSelecionado.id &&
            u.statusRegistroAtivo === 'S',
        );

        if (jaExisteOutro) {
          CustomSwal.quick(
            'warning',
            'Já existe um Representante Técnico ativo vinculado a este CNPJ.',
          );
          return;
        }
      }

      await httpClient.patch(
        `/api/usuariointerface/${usuarioVinculadoSelecionado.id}`,
        {
          tpVinculo: usuarioVinculadoSelecionado.tpVinculo,
          dsObservacao: usuarioVinculadoSelecionado.observacao ?? '',
        },
      );

      CustomSwal.quick('success', 'Perfil atualizado com sucesso!');
      handleShowDetalhes();

      fetchUsuariosVinculadosPorCnpj();
    } catch (error: any) {
      console.error('Erro ao atualizar tipo de vínculo:', error);

      if (isHttpError(error)) {
        const msg = error.response?.data?.message;

        if (
          typeof msg === 'string' &&
          msg.includes('Representante Técnico ativo vinculado a este CNPJ')
        ) {
          CustomSwal.quick('warning', msg);
          return;
        }

        if (
          typeof msg === 'string' &&
          msg.includes('já existe') &&
          msg.toLowerCase().includes('cpf')
        ) {
          CustomSwal.quick('warning', msg);
          return;
        }
      }

      CustomSwal.quick(
        'error',
        'Erro ao atualizar o perfil do usuário vinculado.',
      );
    }
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/ses/ses"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <CustomTable
          headers={headersSesUsuarios}
          data={tableData}
          onRowClick={handleRowClickUsuarioVinculado}
          showPagination={false}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidos,
              fieldObject,
              'sisaf_fornecedores_representantes.xlsx',
              userID,
              'DAF',
              entity,
            )
          }
          inserir
          onClickInserir={handleShowModalVinculoUsuario}
        />
      </BarraInferiorBotoes>

      <CustomOffcanvas
        title="Detalhes do Usuário Vinculado"
        show={showDetalhesUsuario && !!usuarioVinculadoSelecionado}
        onClose={handleShowDetalhes}
        width="50%"
        footerContent={
          <BarraInferiorBotoes>
            <WorkspaceBotoesNew
              label="Desvincular"
              tipo="cancel"
              icone={<FaTrash />}
              onClick={() =>
                handleDesvincularUsuario(usuarioVinculadoSelecionado.id)
              }
              style={{ marginRight: '8px' }}
            />
            <WorkspaceBotoesNew
              label="Salvar Alteração"
              tipo="save"
              onClick={handleAtualizarTpVinculo}
            />
          </BarraInferiorBotoes>
        }
      >
        <WorkspaceFicha>
          {usuarioVinculadoSelecionado && (
            <>
              <Log
                dataRegistro={usuarioVinculadoSelecionado.dataVinculacao}
                usuarioRegistro={
                  usuarioVinculadoSelecionado.usuarioVinculacao?.nomeCompleto ||
                  '---'
                }
              />
              <BoxConteudo boxTitulo="Dados do Usuário">
                <CustomRow
                  style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
                >
                  <CustomCol width="18%">
                    <CustomInputText
                      name="status-vinculacao"
                      title="Status"
                      value={
                        usuarioVinculadoSelecionado.statusInterface === 'S'
                          ? 'Ativo'
                          : 'Pendente'
                      }
                      readOnly
                      onChange={(e) => void e}
                      // style={{
                      //   backgroundColor:
                      //     usuarioVinculadoSelecionado.statusInterface === 'S'
                      //       ? '#abf3aba7'
                      //       : '#ffcecec3',
                      // }}
                    />
                  </CustomCol>

                  <CustomCol width="22%">
                    <CustomInputMask
                      name="cpf-usuario-vinculado"
                      title="CPF"
                      mask="999.999.999-99"
                      value={
                        usuarioVinculadoSelecionado.usuarioId?.cpf || '---'
                      }
                      readOnly
                      onChange={(e) => void e}
                    />
                  </CustomCol>

                  <CustomCol width="22%">
                    <CustomInputDate
                      name="data-vinculacao"
                      title="Data de Vinculação"
                      value={formatDate(
                        usuarioVinculadoSelecionado.dataVinculacao,
                      )}
                      readOnly
                      onChange={(e) => void e}
                    />
                  </CustomCol>
                </CustomRow>

                <CustomRow>
                  <CustomCol>
                    <CustomInputText
                      name="nome-usuario-vinculado"
                      title="Nome Completo"
                      value={
                        usuarioVinculadoSelecionado.usuarioId?.nomeCompleto ||
                        '---'
                      }
                      readOnly
                      onChange={(e) => void e}
                    />
                  </CustomCol>
                </CustomRow>

                <CustomRow>
                  <CustomCol width="22%">
                    <CustomInputMask
                      name="celular-usuario-vinculado"
                      title="Celular"
                      mask="(99) 99999-9999"
                      value={
                        usuarioVinculadoSelecionado.usuarioId?.celular || '---'
                      }
                      readOnly
                      onChange={(e) => void e}
                    />
                  </CustomCol>
                  <CustomCol width="78%">
                    <CustomInputText
                      name="email-usuario-vinculado"
                      title="Email"
                      value={
                        usuarioVinculadoSelecionado.usuarioId?.emailPessoal ||
                        '---'
                      }
                      readOnly
                      onChange={(e) => void e}
                    />
                  </CustomCol>
                </CustomRow>
              </BoxConteudo>
              <BoxConteudo boxTitulo="Observações">
                <CustomRow style={{ marginTop: '-15px' }}>
                  <CustomCol>
                    <CustomInputText
                      name="observacoes-vinculacao"
                      title=""
                      type="textArea"
                      rows={4}
                      value={usuarioVinculadoSelecionado?.observacao ?? ''}
                      onChange={(e) =>
                        setUsuarioVinculadoSelecionado((prev: any) =>
                          prev ? { ...prev, observacao: e.target.value } : prev,
                        )
                      }
                    />
                  </CustomCol>
                </CustomRow>
              </BoxConteudo>
            </>
          )}
        </WorkspaceFicha>
      </CustomOffcanvas>

      <CustomModal
        title="Vincular Novo Usuário"
        open={showModalVinculoUsuario}
        onClose={handleShowModalVinculoUsuario}
      >
        <WorkspaceFicha>
          <CustomRow className="mb-4" style={{ alignItems: 'flex-end' }}>
            <CustomCol width="50%" style={{ display: 'flex', gap: '8px' }}>
              <CustomInputText
                name="buscaUsuario"
                value={cpfBusca}
                title="CPF ou Nome"
                onChange={(e) => setCpfBusca(e.target.value)}
                required
              />

              <CustomButton
                label="Pesquisar"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={handleBuscarUsuario}
                style={{ marginTop: '28px' }}
              />
            </CustomCol>
          </CustomRow>

          <CustomRow>
            <CustomCol width="100%">
              {listaUsuariosEncontrados.length <= 1 ? (
                <CustomInputText
                  name="nome"
                  value={usuarioEncontrado?.nomeCompleto || ''}
                  title="Nome"
                  readOnly
                  onChange={(e) => void e}
                  required
                />
              ) : (
                <CustomSelect
                  name="usuarioSelecionado"
                  value={usuarioSelecionadoId || ''}
                  title="Selecione o usuário encontrado"
                  options={listaUsuariosEncontrados.map((u) => ({
                    label: `${u.nomeCompleto} - ${formataCPF(u.cpf)}`,
                    value: u.id,
                  }))}
                  onChange={(e) => {
                    const selectedId = parseInt(e.target.value, 10);
                    const selectedUser = listaUsuariosEncontrados.find(
                      (u) => u.id === selectedId,
                    );
                    setUsuarioSelecionadoId(selectedId);
                    setUsuarioEncontrado(selectedUser || null);
                    setUsuarioEncontradoId(selectedUser?.id || null);
                  }}
                  required
                />
              )}
            </CustomCol>
          </CustomRow>

          <CustomRow>
            <CustomCol style={{ textAlign: 'right' }}>
              <CustomButton
                label="Vincular Usuário"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={handleVincularUsuario}
                disabled={!usuarioEncontrado}
              />
            </CustomCol>
          </CustomRow>

          <BarraInferiorBotoes />
        </WorkspaceFicha>
      </CustomModal>
    </>
  );
}

export default SESUsuarios;
